export const PUBLISHED_SYNC_TAG_PREFIX = 'sp:'
export const DRAFT_SYNC_TAG_PREFIX = 'sd:'
